import { FieldArray } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { Toggle } from 'libs/form';
import { InputWithHelp, Help } from 'libs/ui';
import { PeriodsLoopInputs } from './periods-loop-inputs';
import { Header, Headers, PeriodsWrapper, Wrapper } from './periods-loop.styled';

export const PeriodsLoop = ({ disabled, zone }) => {
  const { t } = useTranslation();
  const extended = true;

  /**
   * get fields
   * @param {*} extended
   * @returns
   */
  const getFields = (extended) => {
    const k = window.innerWidth < 1450 ? 1.2 : 1.7;
    const fields = [
      { w: 100 * k, title: t('grid.Период'), right: true },
      { w: 80 * k, title: t('form.Тариф'), right: true },
    ];
    if (extended) {
      fields.push({ w: 80 * k, title: t('form.Повтор'), right: true });
      fields.push({ w: 60 * k, title: t('form.Цикл'), $center: true });
    }
    fields.push({ title: '' });
    return fields;
  };
  const fields = getFields(extended);

  return (
    <Wrapper>
      <PeriodsWrapper>
        <InputWithHelp>
          <Toggle className="black" label={t('tariffs.Отменять повторный въезд')} name="secondentry_cancel" type="toggle" disabled={disabled} />
          <Help className="white" info={t('tariffs.Отменять повторный въезд помощь')} />
        </InputWithHelp>

        <Headers>
          {fields.map((el, idx) => {
            const { title, ...rest } = el;
            return (
              <Header {...rest} key={idx}>
                {title}
              </Header>
            );
          })}
        </Headers>
        <FieldArray name="periods" component={PeriodsLoopInputs} disabled={disabled} tableFields={fields} zone={zone} extended={extended} />
      </PeriodsWrapper>
    </Wrapper>
  );
};
